import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'

interface ProtectedRouteProps {
  children: ReactNode
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading, _hasHydrated } = useAuth()
  const location = useLocation()
  
  // Show loading while store is hydrating or authentication is in progress
  if (!_hasHydrated || loading) {
    return (
      <div style={{ 
        minHeight: '100vh', 
        backgroundColor: 'var(--surface-secondary)', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center' 
      }}>
        <div style={{
          width: '32px',
          height: '32px',
          border: '4px solid var(--brand-primary)',
          borderTop: '4px solid transparent',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
      </div>
    )
  }
  
  if (!user) {
    // Redirect to login page with return url
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  
  return <>{children}</>
}